export default __webpack_public_path__ + "static/media/bhojpuri_am_2.0c8223f4.mp3";